import Component from "@base/js/component";

export default class Newsletter extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".newsletter";

  // Defines children that needs to be queried as part of this component
  static children = {
    submit: '.newsletter-form__group [type="submit"]',
    input: ".newsletter-form__input",
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    input: {
      keyup: this.onKeyUp,
    },
  };

  onKeyUp() {
    if (this.children.input.value !== "") {
      this.children.submit.removeAttribute("disabled");
    } else {
      this.children.submit.setAttribute("disabled", "");
    }
  }

  afterInit() {
    this.children.submit.setAttribute("disabled", "");
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
Newsletter.init();
